import ProductLandingWrapper from './ProductLandingWrapper';

export default ProductLandingWrapper;
